import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$')({
  component: NotFoundRoute,
});

function NotFoundRoute() {
  return (
    <div className="flex min-h-screen items-center justify-center p-8 text-center">
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-gray-900">Page not found</h1>
        <p className="text-gray-600">The requested page does not exist.</p>
      </div>
    </div>
  );
}
